import React from 'react';
import { getDocumentThumbnailUrl } from '@/services/documents';
import { FileData } from '@ygtechnologies/rubus-frontend-utilities';
import { FileMetadata } from '@/types';
import { LocalFilePreview, Thumbnail } from '@ygtechnologies/bygr-frontend-component-library';

interface DocumentPreviewProps {
    value: {
        versionId: number;
        fileMetadata: FileMetadata;
        fileData?: FileData;
    };
}

const DocumentPreview: React.FC<DocumentPreviewProps> = ({ value }) => {
    if (value.fileData) {
        return <LocalFilePreview fileData={value.fileData} />;
    }

    return <Thumbnail src={getDocumentThumbnailUrl(value.versionId)} fileMetadata={value.fileMetadata} />;
};

export default DocumentPreview;